<div class="blur_hover">
    <img *ngIf="preview != ''" class="img-fluid preview_bkg" src="{{ preview }}">
</div>

<div class="content_upgrade">
    <h3>Vous voulez débloquer cette fonctionnalité ?</h3>
    <p>
        Pour cela, vous avez besoin d’un forfait “{{plan}}” ou supérieur
    </p>
    <a class="btn btn-primary" href="/app/user/plan">
        Passer au forfait “{{plan}}”
    </a>
</div>
